import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { FailedPaymentsOverview } from '../components/Payments/FailedPaymentsOverview';
import { PaymentHistoryTable } from './PaymentHistoryTable';
import { GenericErrorState } from '../components/GenericErrorState';
import { useAppSelector } from '../redux';
import { selectContactFirstName } from '../features/AuthSlice/AuthSelectors';
import { trackPageView } from '../utils/usageTracker';
import { useFailedPaymentsData } from '../hooks/useFailedPaymentsData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PaymentHistoryPage = () => {
  var _failedPaymentsData$r;
  const {
    loading: failedPaymentsLoading,
    error: failedPaymentsError,
    data: failedPaymentsData
  } = useFailedPaymentsData();
  const contactFirstName = useAppSelector(selectContactFirstName);
  useEffect(() => {
    trackPageView('payment-history-overview');
  }, []);
  if (failedPaymentsError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "PAYMENT_HISTORY_OVERVIEW_LOAD",
      children: /*#__PURE__*/_jsx(MainContentLayout, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentHistory.title"
        }),
        children: /*#__PURE__*/_jsx(GenericErrorState, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PAYMENT_HISTORY_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsx(MainContentLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "paymentHistory.title"
      }),
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "700",
        children: [/*#__PURE__*/_jsx(FailedPaymentsOverview, {
          contactFirstName: contactFirstName,
          failedPaymentGroups: (_failedPaymentsData$r = failedPaymentsData === null || failedPaymentsData === void 0 ? void 0 : failedPaymentsData.results) !== null && _failedPaymentsData$r !== void 0 ? _failedPaymentsData$r : [],
          loading: failedPaymentsLoading && !failedPaymentsData
        }), /*#__PURE__*/_jsx(PaymentHistoryTable, {})]
      })
    })
  });
};